import React from 'react';
import { Box } from '@mui/material';
import { Tab, Tabs } from '@components/tabs';
import { TabLabelWithCount } from '@components/tabs/TabLabelWithCount';
import { useTranslation } from 'react-i18next';
import {
  CompetitionsOverviewFilter,
  ICompetitionsFilterTabs,
} from './interfaces';

const TAB_INDEX: Record<CompetitionsOverviewFilter, number> = {
  all: 0,
  mine: 1,
};

const TAB_VALUE: CompetitionsOverviewFilter[] = ['all', 'mine'];

export const CompetitionsFilterTabs: React.FC<ICompetitionsFilterTabs> = ({
  value,
  enrolledCount,
  onChange,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 2 }}>
      <Tabs
        activeTab={TAB_INDEX[value]}
        onChange={(tabIndex) => onChange(TAB_VALUE[tabIndex])}
      >
        <Tab label={t('competitions:portal.overview.tabs.all')} />
        <Tab
          label={
            <TabLabelWithCount
              label={t('competitions:portal.overview.tabs.mine')}
              count={enrolledCount}
            />
          }
        />
      </Tabs>
    </Box>
  );
};
